import _ from 'lodash';
import { AppName, Feature } from '@common/types';

export const pageSize = 24;

export const APP_IDS = {
  STORE_ID: '215238eb-22a5-4c36-9e7b-e7c08025e04e',
  BOOKING_ID: '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
  BLOG_ID: '14bcded7-0066-7c35-14d7-466cb3f09103',
  MEMBERS_AREA_ID: '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9',
  MULTILINGUAL_ID: '14d84998-ae09-1abf-c6fc-3f3cace5bf19',
  PRICING_PLANS_ID: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
  EVENTS_ID: '140603ad-af8d-84a5-2c80-a0f60cb47351',
  RESTAURANT_ID: '9a5d83fd-8570-482e-81ab-cfa88942ee60',
  USER_CODE_ID: '675bbcef-18d8-41f5-800e-131ec9e08762',
  CMS_ID: '1973457f-c021-4da5-941f-58444ff761d4',
};

export const APP_NAMES = {
  STORE: 'STORE',
  BOOKING: 'BOOKING',
  BLOG: 'BLOG',
  MEMBERS_AREA: 'MEMBERS_AREA',
  MULTILINGUAL: 'MULTILINGUAL',
  PRICING_PLANS: 'PRICING_PLANS',
  EVENTS: 'EVENTS',
  RESTAURANT: 'RESTAURANT',
  USER_CODE: 'USER_CODE',
  CMS: 'CMS',
};

export const appIdToAppNameMap: { [key: string]: string } = {
  [APP_IDS.STORE_ID]: 'STORE',
  [APP_IDS.BOOKING_ID]: 'BOOKING',
  [APP_IDS.BLOG_ID]: 'BLOG',
  [APP_IDS.MEMBERS_AREA_ID]: 'MEMBERS_AREA',
  [APP_IDS.MULTILINGUAL_ID]: 'MULTILINGUAL',
  [APP_IDS.PRICING_PLANS_ID]: 'PRICING_PLANS',
  [APP_IDS.EVENTS_ID]: 'EVENTS',
  [APP_IDS.RESTAURANT_ID]: 'RESTAURANT',
  [APP_IDS.USER_CODE_ID]: 'USER_CODE',
  [APP_IDS.CMS_ID]: 'CMS',
};

export function toAppId(feature: Feature) {
  switch (_.toUpper(feature)) {
    case APP_NAMES.STORE:
      return APP_IDS.STORE_ID;
    case APP_NAMES.BOOKING:
      return APP_IDS.BOOKING_ID;
    case APP_NAMES.BLOG:
      return APP_IDS.BLOG_ID;
    case APP_NAMES.MEMBERS_AREA:
      return APP_IDS.MEMBERS_AREA_ID;
    case APP_NAMES.MULTILINGUAL:
      return APP_IDS.MULTILINGUAL_ID;
    case APP_NAMES.PRICING_PLANS:
      return APP_IDS.PRICING_PLANS_ID;
    case APP_NAMES.EVENTS:
      return APP_IDS.EVENTS_ID;
    case APP_NAMES.RESTAURANT:
      return APP_IDS.RESTAURANT_ID;
    case APP_NAMES.USER_CODE:
      return APP_IDS.USER_CODE_ID;
    case APP_NAMES.CMS:
      return APP_IDS.CMS_ID;
    default:
      return undefined;
  }
}

export const getAppNames = (apps?: string[]) =>
  _.map(apps, (appId) => _.toLower(appIdToAppNameMap[appId]));

export const getStaticAppName = (appId: string) => {
  const nameKey = _.toLower(appIdToAppNameMap[appId]);

  if (nameKey) {
    return {
      name: nameKey,
      isKey: true,
    };
  }
};

const priorityMap = {
  [_.toLower(APP_NAMES.USER_CODE)]: 1,
  [_.toLower(APP_NAMES.CMS)]: 2,
  [_.toLower(APP_NAMES.RESTAURANT)]: 3,
  [_.toLower(APP_NAMES.EVENTS)]: 4,
  [_.toLower(APP_NAMES.PRICING_PLANS)]: 5,
  [_.toLower(APP_NAMES.MULTILINGUAL)]: 6,
  [_.toLower(APP_NAMES.MEMBERS_AREA)]: 7,
  [_.toLower(APP_NAMES.BLOG)]: 8,
  [_.toLower(APP_NAMES.BOOKING)]: 9,
  [_.toLower(APP_NAMES.STORE)]: 10,
};

export const sortAppsByPriority = (apps: AppName[]) => {
  return _.sortBy(
    apps,
    (app) => priorityMap[app.name] || Number.MAX_SAFE_INTEGER,
  );
};
